"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextContainer = exports.StyledFormButton = exports.StyledTextButton = exports.StyledSecondaryButton = exports.StyledPrimaryButton = void 0;

const styled_components_1 = __importStar(require("styled-components"));

const smBtnCss = (0, styled_components_1.css)`
  height: 24px;
  border-radius: 5px;
  padding: 0 10px;
  font-size: ${props => props.theme.fontSizes[11]};
  line-height: ${props => props.theme.lineHeights[15]};
`;
const mdBtnCss = (0, styled_components_1.css)`
  height: 30px;
  border-radius: 4px;
  padding: 0 12px;
  font-size: ${props => props.theme.fontSizes[12]};
  line-height: ${props => props.theme.lineHeights[16]};
`;
const lgBtnCss = (0, styled_components_1.css)`
  height: 45px;
  border-radius: 4px;
  padding: 0 12px;
  font-size: ${props => props.theme.fontSizes[14]};
  line-height: ${props => props.theme.lineHeights[19]};
`;
const BaseButton = styled_components_1.default.button`
  box-sizing: border-box;
  border: 0;
  outline: 0;
  padding: 0;
  background: 0;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s;
  user-select: none;
  ${props => props.isDisabled && (0, styled_components_1.css)`
      cursor: not-allowed;
    `}
`;
exports.StyledPrimaryButton = (0, styled_components_1.default)(BaseButton)`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.primary_700_main};

  ${props => props.size === 'sm' && smBtnCss};
  ${props => props.size === 'md' && mdBtnCss};
  ${props => props.size === 'lg' && lgBtnCss};
  ${props => props.isDisabled ? (0, styled_components_1.css)`
          background-color: ${props.theme.colors.gray_201};
          color: ${props.theme.colors.gray_401};
        ` : (0, styled_components_1.css)`
          &:hover {
            background-color: ${props.theme.colors.primary_601};
          }
        `}
`;
exports.StyledPrimaryButton.defaultProps = {
  size: 'md'
};
exports.StyledSecondaryButton = (0, styled_components_1.default)(BaseButton)`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.primary_700_main};
  background-color: ${props => props.theme.colors.white};
  border: 1px solid;
  border-color: ${props => props.theme.colors.primary_700_main};
  font-weight: ${props => props.theme.fontWeights[2]};

  ${props => props.size === 'sm' && smBtnCss};
  ${props => props.size === 'md' && mdBtnCss};
  ${props => props.size === 'lg' && lgBtnCss};
  ${props => props.isDisabled ? (0, styled_components_1.css)`
          background-color: ${props.theme.colors.gray_201};
          color: ${props.theme.colors.gray_401};
          border-color: ${props.theme.colors.gray_201};
        ` : (0, styled_components_1.css)`
          &:hover {
            background-color: ${props.theme.colors.primary_700_main};
            color: ${props.theme.colors.white};
          }
        `}
`;
exports.StyledSecondaryButton.defaultProps = {
  size: 'sm'
};
const smTextBtnCss = (0, styled_components_1.css)`
  font-size: ${props => props.theme.fontSizes[12]};
  line-height: ${props => props.theme.lineHeights[16]};
`;
const mdTextBtnCss = (0, styled_components_1.css)`
  font-size: ${props => props.theme.fontSizes[14]};
  line-height: ${props => props.theme.lineHeights[19]};
  letter-spacing: 0.08px;
`;
exports.StyledTextButton = (0, styled_components_1.default)(BaseButton)`
  color: ${props => props.theme.colors.primary_700_main};
  ${props => props.size === 'sm' && smTextBtnCss};
  ${props => props.size === 'md' && mdTextBtnCss};
  ${props => props.isDisabled ? (0, styled_components_1.css)`
          color: ${props.theme.colors.gray_401};
        ` : (0, styled_components_1.css)`
          &:hover {
            text-decoration: underline;
          }
        `}
`;
exports.StyledFormButton = (0, styled_components_1.default)(BaseButton)`
  width: 100%;
  height: 30px;
  border: 1px solid;
  border-color: ${props => props.theme.colors.beige_400};
  color: ${props => props.theme.colors.gray_502};
  font-size: ${props => props.theme.fontSizes[12]};
  line-height: ${props => props.theme.lineHeights[16]};
  padding: 0 8px 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  ${props => props.isDisabled ? (0, styled_components_1.css)`
          background-color: ${props.theme.colors.gray_201};
          color: ${props.theme.colors.gray_401};
          border-color: ${props.theme.colors.gray_201};
        ` : (0, styled_components_1.css)`
          &:hover {
            border-color: ${props.theme.colors.primary_700_main};
          }
        `}
  ${props => props.isClicked && (0, styled_components_1.css)`
      border-color: ${props.theme.colors.primary_700_main};
    `}
  svg {
    transform: rotate(-90deg);
    min-width: 16px;
    min-height: 16px;
  }
`;
exports.TextContainer = styled_components_1.default.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;